import { forwardRef } from 'react';
import MuiAvatar from '@mui/material/Avatar';

import { useAvatarVariantStyles } from './config';
import { CustomAvatarProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CustomAvatar = forwardRef<any, CustomAvatarProps>((props, ref) => {
  const { sx, src, skin = 'filled', color = 'primary' } = props;

  // =============== HOOKS
  const colors = useAvatarVariantStyles(skin);

  // =============== VIEWS
  return (
    <MuiAvatar
      ref={ref}
      {...props}
      sx={!src && skin && color ? Object.assign(colors[color], sx) : sx}
    />
  );
});

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default CustomAvatar;
